var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReferal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6141_137",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6141_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.2777 48.2225L69.0418 36.3475L70.2085 36.4442C70.9491 36.4908 71.5441 36.7819 71.9935 37.3175C72.4424 37.8536 72.6668 38.4339 72.6668 39.0583C72.6668 39.4222 72.5882 39.7881 72.431 40.1558C72.2732 40.5242 72.0371 40.8425 71.7227 41.1108L61.2777 50.0833L64.5143 63.9442C64.551 64.0386 64.5741 64.1422 64.5835 64.255C64.593 64.3678 64.5977 64.4619 64.5977 64.5375C64.5977 65.3181 64.3302 65.9467 63.7952 66.4233C63.2602 66.9006 62.6393 67.1392 61.9327 67.1392C61.7182 67.1392 61.4907 67.1067 61.2502 67.0417C61.0096 66.9767 60.7827 66.8842 60.5693 66.7642L59.3893 66.0558L55.2777 48.2225ZM47.6527 24.5142L43.111 13.8892L43.5835 12.7917C43.793 12.2772 44.123 11.8847 44.5735 11.6142C45.0246 11.3436 45.5002 11.2083 46.0002 11.2083C46.4818 11.2083 46.9518 11.3425 47.4102 11.6108C47.8685 11.8797 48.2041 12.278 48.4168 12.8058L53.611 25.0275L47.6527 24.5142ZM22.556 58.7083L35.0002 51.25L47.4443 58.7775L44.1252 44.6667L55.0977 35.1667L40.6527 33.875L35.0002 20.5417L29.3752 33.8333L14.931 35.0833L25.9027 44.5692L22.556 58.7083ZM16.0418 63.625L20.0002 46.5275L6.75017 35C6.43517 34.7317 6.20128 34.4231 6.0485 34.0742C5.89572 33.7253 5.81934 33.3858 5.81934 33.0558C5.81934 32.4097 6.03711 31.8247 6.47267 31.3008C6.90767 30.7764 7.50489 30.4769 8.26434 30.4025L25.7685 28.87L32.5693 12.75C32.7827 12.2222 33.1138 11.8242 33.5627 11.5558C34.0116 11.2869 34.486 11.1525 34.986 11.1525C35.486 11.1525 35.9643 11.2869 36.421 11.5558C36.8777 11.8242 37.2235 12.2222 37.4585 12.75L44.2593 28.87L61.7643 30.4025C62.5049 30.4769 63.0974 30.7758 63.5418 31.2992C63.9863 31.8225 64.2085 32.4064 64.2085 33.0508C64.2085 33.3964 64.1274 33.7406 63.9652 34.0833C63.8035 34.4261 63.5652 34.7317 63.2502 35L50.0002 46.5275L53.986 63.625C54.0416 63.7644 54.0693 63.9689 54.0693 64.2383C54.0693 64.9917 53.8035 65.6194 53.2718 66.1217C52.7396 66.6239 52.1252 66.875 51.4285 66.875C51.328 66.875 50.8657 66.7408 50.0418 66.4725L35.0002 57.4167L19.986 66.4725C19.7454 66.6019 19.5049 66.7014 19.2643 66.7708C19.0232 66.8403 18.7963 66.875 18.5835 66.875C17.8057 66.875 17.1274 66.5533 16.5485 65.91C15.9702 65.2661 15.8013 64.5044 16.0418 63.625Z",
    fill: "#100073"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReferal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/referal.223f00a98ebb4a92837066a72b4d42d8.svg";